module.exports = __webpack_public_path__ + "img/banner-1.dd89c083.png";